import { z } from "zod/v4";

import { generateShortUuid } from "../id";

export const appConfigSchema = z.object({
	userID: z.string().default(() => `anonymous_${generateShortUuid()}`),
});

export type AppConfig = z.infer<typeof appConfigSchema>;
